import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function TruckMoving(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "TruckMoving", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M32.5283 15.5552h6.2391c.5209-.0001 1.0244.1954 1.418.5506.3936.3551.6509.846.7246 1.3826l.8164 5.9483h1.0822c.574 0 1.1245.2373 1.5303.6596.4059.4223.6339.995.6339 1.5923v5.6296c0 .2987-.114.585-.3169.7962-.2029.2112-.4782.3298-.7652.3298H32.5283v-16.889Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.1955 15.5554v6.7556c0 .2986.1145.585.3182.7961.2038.2112.4801.3298.7682.3298h5.4322l-.8197-5.9483c-.074-.5366-.3323-1.0275-.7275-1.3826-.3951-.3552-.9006-.5506-1.4237-.5506h-3.5477Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.3556 12h15.9013c.6025 0 1.1803.2393 1.6063.6653.426.4261.6654 1.0038.6654 1.6063v18.173h-18.173c-.6025 0-1.1803-.2394-1.6063-.6654-.426-.426-.6653-1.0038-.6653-1.6062V14.2716c0-.6025.2393-1.1802.6653-1.6063.426-.426 1.0038-.6653 1.6063-.6653Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.1943 35.9998c1.9636 0 3.5555-1.5919 3.5555-3.5555 0-1.9637-1.5919-3.5556-3.5555-3.5556-1.9637 0-3.5556 1.5919-3.5556 3.5556 0 1.9636 1.5919 3.5555 3.5556 3.5555Zm18.6669 0c1.9637 0 3.5556-1.5919 3.5556-3.5555 0-1.9637-1.5919-3.5556-3.5556-3.5556-1.9636 0-3.5555 1.5919-3.5555 3.5556 0 1.9636 1.5919 3.5555 3.5555 3.5555Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.1958 34.2221c.9818 0 1.7777-.796 1.7777-1.7778 0-.9819-.7959-1.7778-1.7777-1.7778-.9819 0-1.7778.7959-1.7778 1.7778 0 .9818.7959 1.7778 1.7778 1.7778Zm18.6671 0c.9819 0 1.7778-.7959 1.7778-1.7778 0-.9818-.7959-1.7778-1.7778-1.7778-.9818 0-1.7778.796-1.7778 1.7778 0 .9819.796 1.7778 1.7778 1.7778Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M32.5286 26.222H12.084v.8889h20.4446v-.8889Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.75 27h-5c-.19891 0-.38968-.079-.53033-.2197C3.07902 26.6397 3 26.4489 3 26.25c0-.1989.07902-.3897.21967-.5303.14065-.1407.33142-.2197.53033-.2197h5c.19891 0 .38968.079.53033.2197.14065.1406.21967.3314.21967.5303 0 .1989-.07902.3897-.21967.5303C9.13968 26.921 8.94891 27 8.75 27Zm.75-3.75H6c-.19891 0-.38968-.079-.53033-.2197-.14065-.1406-.21967-.3314-.21967-.5303 0-.1989.07902-.3897.21967-.5303.14065-.1407.33142-.2197.53033-.2197h3.5c.19891 0 .38968.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.14062.1407-.33139.2197-.5303.2197Zm.75-3.75H8.5c-.19891 0-.38968-.079-.53033-.2197-.14065-.1406-.21967-.3314-.21967-.5303 0-.1989.07902-.3897.21967-.5303C8.11032 18.079 8.30109 18 8.5 18h1.75c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
TruckMoving.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "TruckMoving"
};
validateTidalLicense();
export {
  TruckMoving
};
//# sourceMappingURL=TruckMoving.js.map
